'use client';

// base
import React, { useEffect, useState } from 'react';

// styles
import { StyledSignUp } from './style';

// constants
import { ciImage, commonImage } from 'constants/images';
import { BasicModal, TextButton } from 'components';
import { SignUpFirstStep } from './FirstStep';
import { SignUpSecondStep } from './SecondStep';
import { PkgType, ReqCreateSignUp, useCreateSignUp, useFetchSignUpSetting } from 'domains/Pkg';
import { useRouter } from 'next/navigation';
import { useAlert } from 'contexts';

interface SignUpProps {
  pkgNo: PkgType;
  open: boolean;
  onClose: () => void;
}

export const SignUp: React.FC<SignUpProps> = ({ onClose, open, pkgNo }) => {
  const [createSignUpRequest, setCreateSignUpRequest] = useState<ReqCreateSignUp>({
    pkgValue: '',
    companyId: '',
    firstName: '',
    lastName: '',
    email: '',
    designationId: '',
    disciplineId: '',
    occupationId: '',
    religionId: '',
    birthDate: '',
    nationId: '',
    bloodType: '',
    iqamaNo: '',
    iqamaExpiryDate: '',
    passportNo: '',
    passportExpiryDate: '',
    gatepassNo: '',
    gatepassExpiryDate: ''
  });

  const [signUpIndex, setSignUpIndex] = useState(1);
  const [agreedTerms, setAgreedTerms] = useState(false);

  const { data } = useFetchSignUpSetting({ data: { pkgValue: pkgNo } });
  const { mutateAsync: signUp } = useCreateSignUp();
  const { showAlert } = useAlert();
  const router = useRouter();

  useEffect(() => {
    if (pkgNo) {
      setCreateSignUpRequest((prev) => ({
        ...prev,
        pkgValue: pkgNo
      }));
    }
  }, [pkgNo]);

  return (
    <BasicModal
      open={open}
      onClose={onClose}
      width={600}
      height={signUpIndex === 1 ? 450 : 750}
      body={
        <StyledSignUp>
          <div className="su-title">
            <div className="su-title-left">Sign Up</div>
            <div className="su-title-right">
              <div className="su-title-right-up">
                <img src={ciImage.gsilLogoNormal} alt="" />
              </div>
              <div className="su-title-right-down">
                {[1, 2].map((num) => (
                  <p
                    key={num}
                    className={`${num === signUpIndex ? 'active' : ''}`}
                    onClick={() => setSignUpIndex(num)}
                  >
                    {num}
                  </p>
                ))}
              </div>
            </div>
          </div>
          <div className="su-body">
            {signUpIndex === 1 && (
              <SignUpFirstStep
                createSignUpRequest={createSignUpRequest}
                setCreateSignUpRequest={setCreateSignUpRequest}
                settings={data}
              />
            )}
            {signUpIndex === 2 && (
              <SignUpSecondStep
                createSignUpRequest={createSignUpRequest}
                setCreateSignUpRequest={setCreateSignUpRequest}
                settings={data}
                agreedTerms={agreedTerms}
                setAgreedTerms={(agreed: boolean) => setAgreedTerms(agreed)}
              />
            )}
          </div>
          <div className="su-footer">
            <TextButton
              // className="prev"
              variant="outlined"
              label={'Prev'}
              onClick={() => {
                if (signUpIndex === 2) {
                  setSignUpIndex(1);
                } else {
                  onClose();
                }
              }}
            />
            <TextButton
              className="continue"
              variant="contained"
              onClick={() => {
                if (signUpIndex === 1) {
                  setSignUpIndex(2);
                } else {
                  if (!agreedTerms) {
                    showAlert('Please check and accept the terms and conditions.');
                    return;
                  }

                  signUp(
                    { data: createSignUpRequest },
                    {
                      onSuccess(otpData) {
                        console.log('OTP fetched successfully:', otpData);
                        if (!otpData.resultObject) {
                          console.error('OTP data is empty or invalid.');
                          return;
                        }

                        const otp = otpData.resultObject;
                        const url = `${otp.pageUrl}/sign-in?otp=${otp.tokenId}&pkgNo=${pkgNo}`;

                        // OTP 발급 성공 후, 해당 패키지로 이동
                        // router.push(url);
                        if (typeof window !== 'undefined') {
                          window.open(url, '_blank', 'noopener,noreferrer');
                          onClose();
                        }
                      },
                      onError(error) {
                        showAlert('Failed to sign up.');
                      }
                    }
                  );
                }
              }}
              label={signUpIndex == 1 ? 'Continue' : 'Save'}
            />
          </div>
        </StyledSignUp>
      }
    ></BasicModal>
  );
};
